const SUPER_ADMIN_ROLE = '超级管理员'

/**
 * 仅超级管理员可见的顶级路由组。
 *
 * 新增一组只需在这里加一条：路由过滤、导航守卫拦截、提示文案会一起跟上。
 * 这只是前端的可见性控制——真正的权限在后端 ums_resource，
 * 少写一条这里不会导致越权，但会让非超管看到点不动的菜单。
 */
const RESTRICTED_GROUPS = [
  { name: 'growthAnalysis', path: '/growth', label: '增长分析' },
  { name: 'seoAnalysis', path: '/seo', label: 'SEO 追踪' }
]

function isGrowthAdmin(roles) {
  return Array.isArray(roles) && roles.includes(SUPER_ADMIN_ROLE)
}

function matchRestrictedGroup(path) {
  if (typeof path !== 'string') return null
  for (const group of RESTRICTED_GROUPS) {
    if (path === group.path || path.startsWith(group.path + '/')) return group
  }
  return null
}

function isGrowthPath(path) {
  return Boolean(matchRestrictedGroup(path))
}

/** 被拦下时展示哪个模块名；匹配不到时给一个不会说错的兜底。 */
function getRestrictedGroupLabel(path) {
  const group = matchRestrictedGroup(path)
  return group ? group.label : '该模块'
}

function getOriginalGrowthLocation(to) {
  const candidates = [to && to.redirectedFrom, to && to.fullPath, to && to.path]

  for (const candidate of candidates) {
    const path = typeof candidate === 'string'
      ? candidate.split(/[?#]/)[0]
      : undefined

    if (!isGrowthPath(path)) continue

    const location = { path }
    if (to && to.query && Object.keys(to.query).length > 0) {
      location.query = to.query
    }
    if (to && to.hash) location.hash = to.hash
    return location
  }

  return null
}

function filterGrowthRoutes(routes, roles) {
  if (isGrowthAdmin(roles)) return routes
  const restrictedNames = RESTRICTED_GROUPS.map(group => group.name)
  return routes.filter(route => route && restrictedNames.indexOf(route.name) === -1)
}

function completeInitialNavigation(accessedRouters, addRoute, to, roles) {
  accessedRouters.forEach(addRoute)
  const originalGrowthLocation = getOriginalGrowthLocation(to)
  const denied = Boolean(originalGrowthLocation) && !isGrowthAdmin(roles)

  return {
    denied,
    deniedLabel: denied ? getRestrictedGroupLabel(originalGrowthLocation.path) : null,
    target: denied
      ? { path: '/home', replace: true }
      : { ...(originalGrowthLocation || to), replace: true },
  }
}

module.exports = {
  SUPER_ADMIN_ROLE,
  RESTRICTED_GROUPS,
  isGrowthAdmin,
  isGrowthPath,
  getRestrictedGroupLabel,
  getOriginalGrowthLocation,
  filterGrowthRoutes,
  completeInitialNavigation,
}
